import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import './Stripe.css'
import { CircularProgress } from "@mui/material";

export default function CheckoutForm({ data }) {
  const redirect_url = `${window.location.origin}/buyCredit/payment-status`;

  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: redirect_url,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <button
        className="stripe-button"
        variant='contained'
        disabled={isLoading || !stripe || !elements}
        id="submit"
      >
        {/* <span id="button-text"> */}
          {isLoading ? (
            <CircularProgress sx={{margin:'auto',color:'primary'}} />
          ) : (
            "Make Payment"
          )}
        {/* </span> */}
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
